const TeamsQueryKeys = {
  all: ['teams'],
};

export default TeamsQueryKeys;
